var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75871 25.3332H7.24137C6.46404 25.3332 5.83337 24.7025 5.83337 23.9252V14.0745C5.83337 13.2972 6.46404 12.6665 7.24137 12.6665H9.75871C10.536 12.6665 11.1667 13.2972 11.1667 14.0745V23.9252C11.1667 24.7025 10.536 25.3332 9.75871 25.3332V25.3332Z",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 14.0961L16.032 7.76142C16.9373 6.58142 18.7053 6.55209 19.6506 7.70009V7.70009C20.004 8.12809 20.196 8.66675 20.196 9.22142V13.5828H24.324C25.1253 13.5828 25.8733 13.9828 26.3186 14.6481L26.7573 15.3028C27.1506 15.8908 27.2653 16.6228 27.0693 17.3014L25.2573 23.5974C24.9613 24.6254 24.0213 25.3334 22.952 25.3334H14.5666C13.9 25.3334 13.2626 25.0561 12.8093 24.5681L11.1666 22.8001",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.42a9f4733fbbd398087b899d14aaea7e.svg";
export { ForwardRef as ReactComponent };